import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { Tenant, BaseResponse } from 'types';

import { apiQuery } from '../../query';

const tagTypes = ['TENANTS'];

export const tenantsApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'tenantsApi',
  endpoints: (build) => ({
    current: build.query<Tenant, void>({
      providesTags: tagTypes,
      transformResponse: (response: BaseResponse<Tenant>) => response.data,
      query: () => ({
        method: 'get',
        url: URL.GET_CURRENT_TENANT,
      }),
    }),
  }),
});

export const { useCurrentQuery } = tenantsApi;
